import _debounce from 'lodash.debounce';
import { ComponentUtils } from '@/mixins';
import ShCard from '@/components/Helpers/ShCard';
import LayoutForSingleConfigurationRow from '../Common/LayoutForSingleConfigurationRow';

// @vue/component
export default {
  name: 'WidgetFooterConfiguration',

  components: {
    ShCard,
    LayoutForSingleConfigurationRow,
  },

  mixins: [ComponentUtils],

  props: {
    widget: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    this.mMakeCopyFromProps('widget');
  },

  methods: {
    informAboutTheCurrentlyEditedElement(element) {
      this.$EventBus.$emit('WidgetScreensConfiguration/SET_FOCUS_TO_EDITED_ELEMENT', element);
    },
    updateWidget: _debounce(function () {
      const newWidgetDetails = this.mCopy.widget;
      this.$store.dispatch('widgets/updateWidget', { newWidgetDetails });
    }, 300),
  },
};
